import { getClient } from "../utils/http";
import { decrypt, encrypt } from "../utils/encryption";

export const uploadFile = async (
  vector_name: string,
  file_name: string,
  base64File: string,
  client: string
) => {
  const payload = {
    vector_name: vector_name,
    file_name: file_name,
    base64File: base64File,
  };
  console.log(payload);
  const response = await getClient(client).post("/upload-file", {
    // data: encrypt(JSON.stringify(payload)),
    data: payload,
    encryption: true,
  });
  return response.status;
};

export const getFilesList = async (vector_name: string, client: string) => {
  const payload = { vector_name: vector_name };
  const response = await getClient(client).post("/list-files", {
    // data: encrypt(JSON.stringify(payload)),
    data: payload,
    encryption: true,
  });
  // const data = JSON.parse(decrypt(response.data.data));
  const data = response.data.data;
  return { files: data.files, questionSuggestions: data.questionSuggestions };
};
